import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import JumpToContent from '@nubank/nuds-web/components/JumpToContent/JumpToContent';

function JumpToContentWithIntl(props) {
  const intl = useIntl();
  const { intlKey } = props;

  return (
    <JumpToContent {...props}>
      {intl.formatMessage({ id: intlKey })}
    </JumpToContent>
  );
}

JumpToContentWithIntl.propTypes = {
  intlKey: PropTypes.string.isRequired,
};

export default JumpToContentWithIntl;
